/**
 * @author TomaszCzura ({}
 */

import * as authApi from './../api/auth-api';
import cookie from 'react-cookie';
import store from './../store';
import * as actions from './../actions/auth-actions';
import SiteSocket from './../socket/SiteSocket';
import {browserHistory} from 'react-router';

const tokenCookieKey = 'token';
const usernameCookieKey = 'username';
const userIdCookieKey = 'userId';
const sessionEndCookieKey = 'sessionEnd';
const userPermissionsCookieKey = 'userPermissions';

export function loggedIn() {
  return !!getToken();
}

export function login(username, password, onResult) {
  if (loggedIn()) {
    if (onResult) onResult({authenticated: true});
  } else {
    authApi.login(username, password, (response) => {
      if (response.authenticated) {
        saveUser(response.token, response.username, response.userId, response.sessionEnd);
      } else {
        clearCookies();
        store.dispatch(actions.userLogoutAction());
      }
      if (onResult) onResult(response);
    });
  }
}

export function logout(onLogout) {
  clearCookies();
  store.dispatch(actions.userLogoutAction());
  SiteSocket.getInstance().disconnect();
  if (onLogout) {
    onLogout();
  } else {
    browserHistory.push('/login');
  }
}

export function setCurrentUser(user) {
  const permissions = user.authorities.map((permission) => permission.authority);
  cookie.save(userPermissionsCookieKey, permissions, {path: '/', sameSite: 'lax'});
}

export function saveUser(token, username, userId, sessionEnd) {
  const options = {path: '/'};

  cookie.save(tokenCookieKey, token, options);
  cookie.save(usernameCookieKey, username, options);
  cookie.save(userIdCookieKey, userId, options);
  cookie.save(sessionEndCookieKey, sessionEnd, options);
}

export function getCurrentUserPermissions() {
  return cookie.load(userPermissionsCookieKey);
}

export function getToken() {
  return cookie.load(tokenCookieKey);
}

export function getCurrentUserId() {
  return cookie.load(userIdCookieKey);
}

export function clearCookies() {
  cookie.remove(tokenCookieKey);
  cookie.remove(usernameCookieKey);
  cookie.remove(userIdCookieKey);
  cookie.remove(sessionEndCookieKey);
  cookie.remove(userPermissionsCookieKey);
}

export function getSessionEnd() {
  const today = new Date();
  return cookie.load(sessionEndCookieKey) || new Date().setDate(today.getDate() + 365);
}

export function renewToken(response) {
  if (response.authenticated) {
    saveUser(response.token, response.email, response.userRole, response.userId, response.sessionEnd);
  } else {
    logout();
  }
}
